import React from "react";
import { StyleSheet, View } from "react-native";
import appStyles from "../../appStyles";
import ManaButton from "../common/ManaButton";

export default function OnboardingButtons({
  onboardingScreen,
  isLastSlide = false,
  goHome = () => {},
  changeScreen = () => {},
}) {
  const startOnbboardingProcess = () => {
    changeScreen(1);
  };

  return (
    <View style={[appStyles.footerButtons, appStyles.verticalFooterButtons]}>
      {isLastSlide ? (
        <ManaButton
          isMainButton
          text={"Get Started"}
          onPress={() => changeScreen(1)}
          style={styles.button}
          styleText={styles.startButtonText}
        />
      ) : onboardingScreen == 0 ? (
        <>
          <ManaButton
            isMainButton
            text={"Yes (Login)"}
            onPress={goHome}
            style={styles.button}
            styleText={styles.startButtonText}
          />
          <ManaButton
            text="No"
            onPress={startOnbboardingProcess}
            style={styles.button}
            styleText={styles.startButtonText}
          />
        </>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  button: {
    width: 158,
    height: 40,
    marginBottom: 10,
    borderRadius: 1,

    shadowOffset: { width: 0, height: 4 },
    shadowColor: "#000",
    shadowOpacity: 0.1,
    shadowRadius: 5,
    elevation: 5,
  },
  startButtonText: {
    fontFamily: "Montserrat",
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    textAlign: "center",
  },
});
